import { useEffect, useState } from 'react';
import MobileTopSectionWithFilter from '@/TRC/components/TopSections/mobileTopSectionWithFilter';
import TopSectionWithFilter from '@/TRC/components/TopSections/topSectionWithFilter';
import api from '@/data/api';
import Toast from '@/utils/toastManager';
import TRC_PAGE_CATEGORIES from '@/TRC/constants/trcCategories';
import TRC_FILE_TYPE from '@/TRC/constants/trcFileType';
import LessonGrid from '@/TRC/pages/LessonPlans/components/grid';

const TRCLessonPlans = ({ topContent = null, basePath }) => {
	const [contents, setContents] = useState();

	useEffect(() => {
		async function fetchPdf() {
			try {
				const response = await api.fetchContent({ category: TRC_PAGE_CATEGORIES.LESSON_PLANS });

				setContents(response?.data);
			} catch (err) {
				Toast.error(err.message || 'Something went wrong');
			}
		}
		fetchPdf();
	}, []);
	return (
		<div className="d-flex flex-column gap-2">
			<MobileTopSectionWithFilter
				contents={contents}
				setContents={setContents}
				category={TRC_PAGE_CATEGORIES.LESSON_PLANS}
				containsPdf
			/>
			<TopSectionWithFilter
				contents={contents}
				setContents={setContents}
				category={TRC_PAGE_CATEGORIES.LESSON_PLANS}
				contentType={TRC_FILE_TYPE.PDF}
				containsPdf
			/>
			{topContent}
			<LessonGrid contents={contents} basePath={basePath} />
		</div>
	);
};

export default TRCLessonPlans;
